import * as React from 'react';
import "./static/NavHeader.scss";
class NavHeader extends React.Component< {name: string, organisationName: string}, {} > {
    render() {
        return ( 
            <div className="nav-header-container">
                <div className="nav-header">
                    <h2>{this.props.name}</h2>
                    <h4>{this.props.organisationName}</h4>
                </div>
            </div>
        );
    }
}
export default NavHeader;


// WEBPACK FOOTER //
// ./src/component/NavHeader/NavHeader.tsx